module.exports = __webpack_public_path__ + "dobroshrift.7bc5141495a3ad6ddae4659959c3afc3.svg";